module.exports = __webpack_public_path__ + "img/cheque-guide.a982b2cf.png";